import { Route, Routes } from '@angular/router';
import { AuthGuard } from './shared/guard';
import { Authority } from './shared/config/authority.constants';


const routesAdm: Route = {
    path: 'dashboard-adm',
    data: {
        authorities: [Authority.ADMIN],
    },
    canActivate: [AuthGuard],
    children: [
        {
            path: '',
            loadComponent: () => import('./layout/dashboard-adm/dashboard-adm.component').then(m => m.DashboardAdmComponent)
        },
        {
            path: 'venda',
            loadComponent: () => import('./layout/dashboard-adm/venda/venda.component').then(m => m.VendaComponent)
        },
        {
            path: 'projeto',
            loadComponent: () => import('./layout/dashboard-adm/projetos/projetos.component').then(m => m.ProjetosComponent)
        },
        {
            path: 'templates',
            loadComponent: () => import('./layout/dashboard-adm/templates/templates.component').then(m => m.TemplatesComponent)
        },
        {
            path: 'certificados',
            loadComponent: () => import('./layout/dashboard-adm/certificados/certificados.component').then(m => m.CertificadosComponent)
        },
        {
            path: 'cadastro-aceite',
            loadComponent: () => import('./layout/dashboard-adm/cadastro-termos/cadastro-termos.component').then(m => m.CadastroTermosComponent)
        },
        {
            path: 'contas',
            loadComponent: () => import('./layout/dashboard-adm/contas-ativas/contas-ativas.component').then(m => m.ContasAtivasComponent)
        },
        {
            path: 'produtor',
            loadComponent: () => import('./layout/dashboard-adm/contas-ativas/produtor/produtor.component').then(m => m.ProdutorComponent)
        },
        {
            path: 'produtor-data/:id',
            loadComponent: () => import('./layout/dashboard-adm/contas-ativas/produtor/detalhes-produtor/detalhes-produtor.component').then(m => m.DetalhesProdutorComponent)
        },
        {
            path: 'comprador',
            loadComponent: () => import('./layout/dashboard-adm/contas-ativas/comprador/comprador.component').then(m => m.CompradorComponent)
        },
        {
            path: 'comprador/:id',
            loadComponent: () => import('./layout/dashboard-adm/contas-ativas/comprador/detalhes-comprador/detalhes-comprador.component').then(m => m.DetalhesCompradorComponent)
        },
        {
            path: 'relatorio',
            loadComponent: () => import('./layout/dashboard-adm/relatorio/relatorio.component').then(m => m.RelatorioComponent)
        },
        {
            path: 'relatorio-vendas',
            loadComponent: () => import('./layout/dashboard-adm/relatorio/relatorio-vendas/relatorio-vendas.component').then(m => m.RelatorioVendasComponent)
        },
        {
            path: 'relatorio-pagamento',
            loadComponent: () => import('./layout/dashboard-adm/relatorio/relatorio-pagamento/relatorio-pagamento.component').then(m => m.RelatorioPagamentoComponent)
        },
        {
            path: 'relatorio-aprovados',
            loadComponent: () => import('./layout/dashboard-adm/relatorio/relatorio-aprovados/relatorio-aprovados.component').then(m => m.RelatorioAprovadosComponent)
        },
        {
            path: 'relatorio-beneficiados',
            loadComponent: () => import('./layout/dashboard-adm/relatorio/relatorio-produtores-beneficiados/relatorio-produtores-beneficiados.component').then(m => m.RelatorioProdutoresBeneficiadosComponent)
        },
        {
            path: 'relatorio-car-compra',
            loadComponent: () => import('./layout/dashboard-adm/relatorio/relatorio-car-compra/relatorio-car-compra.component').then(m => m.RelatorioCarCompraComponent)
        },
        {
            path: 'documento/:id',
            loadComponent: () => import('./layout/dashboard-adm/certificados/documentos/documentos.component').then(m => m.DocumentosComponent)
        },
        {
            path: 'produtor-cooperativa',
            loadComponent: () => import('./layout/dashboard-adm/produtor-cooperativa/produtor-cooperativa.component').then(m => m.ProdutorCooperativaComponent)
        },
        {
            path: 'simulador',
            loadComponent: () => import('./layout/dashboard-adm/simulador/simulador.component').then(m => m.SimuladorComponent)
        },
        {
            path: 'simulador-v2',
            loadComponent: () => import('./layout/dashboard-adm/simulador-v2/simulador-v2.component').then(m => m.SimuladorV2Component)
        },
        {
            path: 'venda-cooperativa',
            loadComponent: () => import('./layout/dashboard-adm/venda-cooperativa/venda-cooperativa.component').then(m => m.VendaCooperativaComponent)
        },
        {
            path: 'image-seg',
            loadComponent: () => import('./layout/dashboard-adm/image-segmentation/image-segmentation.component').then(m => m.ImageSegmentationComponent)
        }

    ]
}

export const routes: Routes = [
    {
        path: 'calc-pessoa-fisica',
        loadComponent: () => import('./calculadora-v2/calc-pessoa-fisica/calc-pessoa-fisica.component').then(m => m.CalcPessoaFisicaComponent)
    },
    {
        path: 'calc-pessoa-juridica',
        children: [
            {
                path: '',
                loadComponent: () => import('./calculadora-v2/calc-pessoa-juridica/calc-pessoa-juridica.component').then(m => m.CalcPessoaJuridicaComponent)
            },
            {
                path: 'administrativo',
                loadComponent: () => import('./calculadora-v2/calc-pessoa-juridica/calc-administrativo/calc-administrativo.component').then(m => m.CalcAdmnistrativoComponent)
            },
            {
                path: 'agronegócio',
                loadComponent: () => import('./calculadora-v2/calc-pessoa-juridica/calc-agro/calc-agro.component').then(m => m.CalcAgroComponent)
            },
            {
                path: 'construção civil',
                loadComponent: () => import('./calculadora-v2/calc-pessoa-juridica/calc-construcao/calc-construcao.component').then(m => m.CalcConstrucaoComponent)
            },
            {
                path: 'confecção',
                loadComponent: () => import('./calculadora-v2/calc-pessoa-juridica/calc-confeccao/calc-confeccao.component').then(m => m.CalcConfeccaoComponent)
            }
        ]
    },
    {
        path: 'politica',
        loadComponent: () => import('./politica/politica.component').then(m => m.PoliticaComponent)
    },
    {
        path: 'termos',
        loadComponent: () => import('./termos/termos.component').then(m => m.TermosComponent)
    },
    {
        path: 'transparencia',
        loadComponent: () => import('./transparencia/transparencia.component').then(m => m.TransparenciaComponent)
    },
    {
        path: 'site',
        children: [
            {
                path: '',
                loadComponent: () => import('./site/site.component').then(m => m.SiteComponent)
            },
            {
                path: 'parana-faz-ciencia',
                loadComponent: () => import('./site/parana-faz-ciencia/parana-faz-ciencia.component').then(m => m.ParanaFazCienciaComponent)
            },
            {
                path: 'landpage',
                loadComponent: () => import('./site/land-page/land-page.component').then(m => m.LandPageComponent)
            },
            {
                path: 'sobre',
                loadComponent: () => import('./site/sobre/sobre.component').then(m => m.SobreComponent)
            },
            {
                path: 'solucoes',
                loadComponent: () => import('./site/solucoes/solucoes.component').then(m => m.SolucoesComponent)
            },
            {
                path: 'projetos',
                loadComponent: () => import('./site/projetos/projetos.component').then(m => m.ProjetosComponent)
            },
            {
                path: 'faleconosco',
                loadComponent: () => import('./site/faleconosco/faleconosco.component').then(m => m.FaleconoscoComponent)
            },
            {
                path: 'login',
                loadComponent: () => import('./site/login/login.component').then(m => m.LoginComponent)
            },
            {
                path: 'criarconta',
                loadComponent: () => import('./site/criar-minha-conta/criar-minha-conta.component').then(m => m.CriarMinhaContaComponent)
            },
            {
                path: 'calculadora-menu',
                loadComponent: () => import('./site/calculadora-menu/calculadora-menu.component').then(m => m.CalculadoraMenuComponent)
            },
            {
                path: 'lar-mockup',
                loadComponent: () => import('./site/pdflar/pdf.component').then(m => m.pdfLarComponent),
                data: {
                    title: 'Certificado'
                }
            },
            {
                path: ':id',
                loadComponent: () => import('./site/pdf/pdf.component').then(m => m.pdfComponent),
                data: {
                    title: 'Certificado'
                }
            },
            {
                path: 'pdfsancorclientes/:id',
                loadComponent: () => import('./site/pdfsancorclientes/pdf.component').then(m => m.pdfSancorClientesComponent),
                data: {
                    title: 'Certificado'
                }
            },
            {
                path: 'trocarsenha/:id',
                loadComponent: () => import('./site/trocarsenha/trocarsenha.component').then(m => m.TrocarSenhaComponent),
                data: {
                    title: 'Trocar senha'
                }
            },
            {
                path: 'compensacao/:id',
                loadComponent: () => import('./site/compensacao-user/compensacao-user.component').then(m => m.CompensacaoUserComponent)
            },
        ]
    },
    {
        path: 'dashboard',
        data: {
            authorities: [Authority.PRODUTOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/dashboard/dashboard.component').then(m => m.DashboardComponent)
    },
    {
        path: 'screen1',
        data: {
            authorities: [Authority.PRODUTOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/screen1/screen1.component').then(m => m.Screen1Component)
    },
    {
        path: 'solicitar-resgate',
        data: {
            authorities: [Authority.PRODUTOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/dashboard/solicitar-resgate/solicitar-resgate.component').then(m => m.SolicitarResgateComponent)
    },
    {
        path: 'uploadnf',
        data: {
            authorities: [Authority.PRODUTOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/uploadnf/uploadnf.component').then(m => m.UploadNFComponent)
    },
    {
        path: 'uploadCar',
        data: {
            authorities: [Authority.PRODUTOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/dashboard/uploadCar/uploadcar.component').then(m => m.UploadCarComponent)
    },
    {
        path: 'lista-notas',
        data: {
            authorities: [Authority.PRODUTOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/dashboard/lista-notas/lista-notas.component').then(m => m.ListaNotasComponent)
    },
    {
        path: 'conta-bancaria',
        data: {
            authorities: [Authority.PRODUTOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/conta-bancaria/conta-bancaria.component').then(m => m.ContaBancariaComponent)
    },
    {
        path: 'dashboard-comprador',
        data: {
            authorities: [Authority.COMPRADOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/dashboard-comprador/dashboard-comprador.component').then(m => m.DashboardCompradorComponent)
    },
    {
        path: 'comprar',
        data: {
            authorities: [Authority.COMPRADOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/dashboard-comprador/comprar/comprar.component').then(m => m.ComprarComponent)
    },
    {
        path: 'certificado',
        data: {
            authorities: [Authority.COMPRADOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/certificado/certificado.component').then(m => m.CertificadoComponent)
    },
    {
        path: 'meus-certificados',
        // data: {
        //     authorities: [Authority.COMPRADOR],
        // },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/meus-certificados/meus-certificados.component').then(m => m.MeusCertificadosComponent)
    },
    {
        path: 'minhas-compras',
        // data: {
        //     authorities: [Authority.COMPRADOR],
        // },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/dashboard-comprador/minhas-compras/minhas-compras.component').then(m => m.MinhasComprasComponent)
    },
    {
        path: 'meus-resgates',
        // data: {
        //     authorities: [Authority.COMPRADOR],
        // },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/dashboard/meus-resgates/meus-resgates.component').then(m => m.MeusResgatesComponent)
    },
    {
        path: 'calculadora',
        data: {
            authorities: [Authority.COMPRADOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/calculadora/calculadora.component').then(m => m.CalculadoraComponent)
    },
    {
        path: 'meus-dados',
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/meus-dados/meus-dados.component').then(m => m.MeusDadosComponent)
    },
    {
        path: 'meus-projetos',
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/users-dashboard/dashboard-comprador/meus-projetos/meus-projetos.component').then(m => m.MeusProjetosComponent)
    },
    {
        path: 'calc-menu',
        data: {
            authorities: [Authority.COMPRADOR],
        },
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/calc-menu/calc-menu.component').then(m => m.CalcMenuComponent)
    },
    routesAdm,
    {
        path: '',
        redirectTo: 'site',
        pathMatch: 'full'
    }
];

